/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { useTranslation } from 'react-i18next';

import { removeUserSession, restartUserSession } from '../../utils/user/session';

import LogoutIcon from '@icons/Logout.svg';

interface Props {
  className?: string;
}

export const LogoutButton = ({ className }: Props) => {
  const { t: tCommon } = useTranslation('common', { keyPrefix: 'common' });

  const logoutHandler = async () => {
    const content = document.getElementById('scrollContainer') || document.body;
    content.classList.add('opacity-50', 'transition-opacity', 'duration-200');

    await removeUserSession(true);
    await restartUserSession();

    content.classList.remove('opacity-50', 'transition-opacity', 'duration-200');
  };

  return (
    <button
      className={className}
      onClick={() => {
        void logoutHandler();
      }}
      type='button'
      data-cy='logout-btn'
    >
      <LogoutIcon className='pointer-events-none relative size-5 shrink-0 text-neutral-text-medium' />
      {tCommon('logout')}
    </button>
  );
};
